import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'horaMeridiana'
})
export class HoraMeridianaPipe implements PipeTransform {

  transform(value: string): string {
    return moment(value, "HH:mm:ss").format("hh:mm a");
  }
}
